/* global google */

import React from "react";
import axios from 'axios';
import cookie from 'react-cookie';

const config = require('./config');
const APIURL = config.path.apiUrl;
const APPID = config.ids.appId;

class Autocomplete extends React.Component {
  constructor(props) {
    super(props);
		this.state = { orderHandled: '' };
	}

	componentDidMount() {
		
		var input = document.getElementById('pac-input');
		var options = {componentRestrictions: {country: "id"}};
		
		var autocomplete = new google.maps.places.Autocomplete(input,options);
		
		autocomplete.addListener('place_changed',function() {
			document.getElementById("location-error").style.display = 'none';
			var place = autocomplete.getPlace();
			var latitude = place.geometry.location.lat();
			var longitude = place.geometry.location.lng();
			var locationAddress = place.formatted_address;
			cookie.save('Autolatitude',latitude);
			cookie.save('Autolongitude',longitude);
			cookie.save('AutolocationAddress',locationAddress);
		});
	}
  

  render() {
    return (
      <div className="pac-cardinfo" id="pac-card">
			<div id="pac-containerinfo">
				<input id="pac-input" className="location_address_filed" name="location_address" type="text" placeholder="Enter a location" />
				<div id="location-error"></div>
			</div>
		</div>
    );
  }
}

export default Autocomplete;




// WEBPACK FOOTER //
// ./src/Autocomplete.js